import { FC } from 'react'
import { useField } from 'react-final-form'

import TextField, {
  Props as TextFieldProps,
} from '~/form/components/molecules/TextField'

type Props = Pick<TextFieldProps, 'isConfirm' | 'required'>

const NAME = 'requestJobCategory'

const RequestJobCategoryField: FC<Props> = (props) => {
  const {
    input: { value },
  } = useField(NAME)

  if (props.isConfirm && !value) return null

  return (
    <TextField
      name={NAME}
      ariaLabel='掲載希望職種'
      label='掲載希望職種'
      placeholder='デザイナー'
      {...props}
    />
  )
}

RequestJobCategoryField.displayName = 'requestJobCategory'

export default RequestJobCategoryField
